import { useState } from "react";
import { Plus, Star } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";
import { imgUrl, rupiah } from "@/lib/api";
import { MenuImageViewer } from "@/components/MenuImageViewer";

export const MenuCard = ({ item, siblings, menu }) => {
  const { add, items } = useCart();
  const inCart = items.find((i) => i.id === item.id)?.qty || 0;
  const [zoom, setZoom] = useState(false);

  const onAdd = () => {
    add(item);
    toast.success(`${item.name} ditambahkan`, { duration: 1200 });
  };

  return (
    <article className="group card-paper rounded-xl sm:rounded-2xl overflow-hidden flex flex-col hover:shadow-[0_14px_30px_-20px_rgba(21,94,173,0.35)] transition-shadow" data-testid={`menu-item-card-${item.id}`}>
      <div className="relative aspect-square sm:aspect-[4/3] overflow-hidden bg-sage-50">
        <button type="button" onClick={() => setZoom(true)} className="block w-full h-full cursor-zoom-in" aria-label={`Perbesar gambar ${item.name}`} data-testid={`menu-item-image-${item.id}`}>
          <img src={imgUrl(item.image)} alt={item.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        </button>
        <MenuImageViewer items={siblings || [item]} startId={item.id} open={zoom} onOpenChange={setZoom} menu={menu} />
        {item.rank > 0 && (
          <span className="absolute top-1.5 right-1.5 sm:top-3 sm:right-3 bg-amber-400 text-ink text-[9px] sm:text-xs font-bold px-1.5 sm:px-2.5 py-0.5 sm:py-1 rounded-full flex items-center gap-0.5 sm:gap-1 shadow" data-testid={`menu-item-bestseller-${item.id}`}>
            <Star className="w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 fill-ink" /> Terlaris #{item.rank}
          </span>
        )}
        {inCart > 0 && (
          <span className="absolute top-1.5 left-1.5 sm:top-3 sm:left-3 bg-forest text-paper text-[9px] sm:text-xs font-bold px-1.5 sm:px-2.5 py-0.5 sm:py-1 rounded-full" data-testid={`menu-item-incart-${item.id}`}>{inCart}×<span className="hidden sm:inline"> di keranjang</span></span>
        )}
      </div>
      <div className="flex flex-1 flex-col sm:flex-row sm:items-end justify-between gap-1.5 sm:gap-3 p-2 sm:p-4">
        <div className="min-w-0">
          <h3 className="font-semibold text-ink text-xs sm:text-lg leading-tight line-clamp-2">{item.name}</h3>
          {item.description && <p className="hidden sm:block text-xs text-muted2 mt-1 line-clamp-2">{item.description}</p>}
          <div className="hidden sm:block text-ink/80 mt-1.5 font-medium" data-testid={`menu-item-price-${item.id}`}>{rupiah(item.price)}</div>
          {item.sold > 0 && <div className="text-[10px] sm:text-xs text-muted2 mt-0.5 sm:mt-1" data-testid={`menu-item-sold-${item.id}`}>{item.sold} terjual</div>}
        </div>
        <div className="flex items-center justify-between gap-1 sm:contents">
          <div className="text-ink/80 text-xs sm:text-base font-semibold sm:font-medium sm:hidden" data-testid={`menu-item-price-mobile-${item.id}`}>{rupiah(item.price)}</div>
          <button onClick={onAdd} aria-label={`Tambah ${item.name}`} data-testid={`add-to-cart-button-${item.id}`}
            className="shrink-0 w-7 h-7 sm:w-10 sm:h-10 rounded-md sm:rounded-lg bg-forest text-paper grid place-items-center hover:bg-forest-dark active:scale-90 transition-[background-color,transform]">
            <Plus className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={2.4} />
          </button>
        </div>
      </div>
    </article>
  );
};
